import instance from "../api";
import ApiConstant from "../../constants/api.constants";
import Helpers from "../../utilities/helpers";

const getProvisionDeviceSummary = async (data: any) => {
  try {
    const response = await instance.post(
      ApiConstant.getProvisionDeviceSummary,
      data
    );
    return response.data;
  } catch (error) {
    Helpers.consoleLogger('Get provision device summary failed', error, 'error');
    return (error as any).response;
  }
};

const addProvisionDeviceData = async (data: any) => {
  try {
    const response = await instance.post(ApiConstant.addProvisionDevice, data);
    return response.data;
  } catch (error) {
    Helpers.consoleLogger('Add provision device data failed', error, 'error');
    return (error as any).response;
  }
};

const getDeviceSites = async (data:any) => {
  try {
    const params = {
      PageSize: data.PageSize,
      PageNumber: data.PageNumber,
      ...(data.SortBy ? { SortBy: data.SortBy } : {}),
      ...(data.SortOrder ? { SortOrder: data.SortOrder } : {}),
      ...(data.SearchText ? { SearchText: data.SearchText } : {}),
    };
    const response = await instance.get(ApiConstant.getProvisionSites,{params});
    return response.data;
  } catch (error) {
    Helpers.consoleLogger('Get device sites failed', error, 'error');
    return (error as any).response;
  }
};

const getDevicePumps = async () => {
  try {
    const response = await instance.get(ApiConstant.getProvisionPump);
    return response.data;
  } catch (error) {
    Helpers.consoleLogger('Get device pumps failed', error, 'error');
    return (error as any).response;
  }
};

const getDevicePowerType = async () => {
  try {
    const response = await instance.get(ApiConstant.getDevicePowerType);
    return response.data;
  } catch (error) {
    Helpers.consoleLogger('Get device power type failed', error, 'error');
    return (error as any).response;
  }
};

const getDeviceTanks = async (data:any) => {
  try {
    const params = {
      SiteId: data.SiteId,
      PageSize: data.PageSize,
      PageNumber: data.PageNumber,
      ...(data.SortBy ? { SortBy: data.SortBy } : {}),
      ...(data.SortOrder ? { SortOrder: data.SortOrder } : {}),
      ...(data.SearchText ? { SearchText: data.SearchText } : {}),
    };
    const response = await instance.get(ApiConstant.getProvisionTank,{params});
    return response.data;
  } catch (error) {
    Helpers.consoleLogger('Get device tanks failed', error, 'error');
    return (error as any).response;
  }
};

const getDecviceStatusCheck = async (data: any) => {
  try {
    const params = {
      deviceId: data,
    };
    const response = await instance.get(ApiConstant.getDecviceStatus, {
      params,
    });
    return response.data;
  } catch (error) {
    Helpers.consoleLogger('Get device status check failed', error, 'error');
    return (error as any).response;
  }
};

const getDevices = async (data: any) => {
  try {
    const params = {
      skip: data.skip,
      limit: data.limit,
      serialNo: data.serialNo,
    };
    const response = await instance.get(ApiConstant.getDevices, { params });
    return response.data;
  } catch (error) {
    Helpers.consoleLogger('Get devices failed', error, 'error');
    return (error as any).response;
  }
};

const ProvisionDeviceService = {
  getProvisionDeviceSummary,
  getDeviceSites,
  getDeviceTanks,
  getDevicePumps,
  getDecviceStatusCheck,
  addProvisionDeviceData,
  getDevices,
  getDevicePowerType
};

export default ProvisionDeviceService;
